<template>
    <Dropdown
        transfer-class-name="headerDropdown"
        transfer
        :placement="placement"
    >
        <DropdownItem>
            <Icon
                v-if="menuItem.icon"
                :custom="'bico-font ' + menuItem.icon"
            />
            <Icon
                v-else
                :custom="'bico-font bico-' + $appData.customIcons[menuItem.menuType]"
            />
            {{menuItem.name}}
            <Icon :type="'ios-arrow-'+(placement=='bottom'?'down':'forward')"></Icon>
        </DropdownItem>
        <DropdownMenu slot="list">
            <DropdownItem
                v-for="childItem in menuItemList"
                :key="childItem._id"
                :selected="activeName==childItem._id"
                @click.native.stop="selectMenu(childItem._id)"
            >
                <Icon
                    v-if="childItem.icon"
                    :custom="'bico-font ' + childItem.icon"
                />
                <Icon
                    v-else
                    :custom="'bico-font bico-' + $appData.customIcons[childItem.menuType]"
                />
                {{childItem.name}}
            </DropdownItem>
            <header-dropdown
                v-for="menus in menuItem.children"
                :key="menus._id"
                placement="right-start"
                :activeName="activeName"
                :menuItem="menus"
                @selectMenu="selectMenu"
            >
            </header-dropdown>
            <DropdownItem
                v-if="fileItem"
                :key="fileItem._id"
                :selected="activeName==fileItem._id"
                @click.native.stop="selectMenu(fileItem._id)"
            >
                <Icon
                    v-if="fileItem.icon"
                    :custom="'bico-font ' + fileItem.icon"
                />
                <Icon
                    v-else
                    :custom="'bico-font bico-' + $appData.customIcons[fileItem.menuType]"
                />
                {{fileItem.name}}
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        name: "headerDropdown",
        components: {},
        props: {
            menuItem: {
                type: Object,
                default () {
                    return {};
                }
            },
            placement: {
                type: String,
                default: "bottom"
            },
            activeName: String
        },
        data () {
            return {
            };
        },
        computed: {
            menuItemList () {
                if (this.menuItem.menuItems.find(item => item.menuType == "FileDirectory")) {
                    return this.menuItem.menuItems.slice(0, this.menuItem.menuItems.length - 1);
                } else {
                    return this.menuItem.menuItems;
                }
            },
            fileItem () {
                return this.menuItem.menuItems.find(item => item.menuType == "FileDirectory");
            }
        },
        created () {
            let childItem = this.menuItem.menuItems.find(item => item._id == this.activeName);
            if (childItem) {
                this.$emit("selectMenu", childItem._id, this.menuItem);
            };
        },
        methods: {
            selectMenu (menuItem) {
                this.$emit("selectMenu", menuItem, this.menuItem);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/headerDropdown.vue